<script>
export default {

};
</script>

<template lang='pug'>
svg.inline-block(
  xmlns='http://www.w3.org/2000/svg',
  width='13',
  height='8',
  viewbox='0 0 13 8',
)
  path.stroke-current(
    fill='none',
    stroke-linecap='round',
    stroke-linejoin='round',
    stroke-miterlimit='50', d='M1 1v0l5.5 6v0L12 1v0',
  )
</template>

<style>
@import '~import/index';

</style>